export const useUlid = () => {
  const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32 alphabet without I, L, O, U
  const TIME_LEN = 10; // Length of the timestamp portion
  const RANDOM_LEN = 16; // Length of the random portion

  const make = () => {
    // Generate the timestamp portion (48 bits)
    let now = Date.now(); // Get the current time in milliseconds
    let timestamp = "";

    for (let i = 0; i < TIME_LEN; i++) {
      timestamp = ENCODING[now % 32] + timestamp;
      now = Math.floor(now / 32);
    }

    // Generate the randomness portion (80 bits)
    let randomness = "";
    for (let i = 0; i < RANDOM_LEN; i++) {
      randomness += ENCODING[Math.floor(Math.random() * 32)];
    }

    return timestamp + randomness;
  };

  // Return the generateULID function so it can be used in components or pages
  return { make };
};
